import { CreateProjectTaskMutationVariables } from 'generated/resources/graphql'

import { defaultStatus } from 'modules/tasks/lib/status'

const defaultTask = (projectId: string): CreateProjectTaskMutationVariables => {
  return {
    name: '',
    projectId: projectId,
    content: '',
    status: defaultStatus().status,
  }
}

export const useTaskForm = (projectId: string, task: CreateProjectTaskMutationVariables | null) => {
  const values = task ? task : defaultTask(projectId)

  return {
    values,
  }
}
